
const printDate = (ts) => {
	const d = new Date(ts * 1000);
	return d.toLocaleString();
}

export {printDate}